import { DocLayout } from './DocLayout';

export default function DocInvitatii() {
  return (
    <DocLayout title="Invitații">
      <h2>Prezentare generală</h2>
      <p>
        Activitățile marcate ca „doar cu invitație" permit participarea exclusiv persoanelor invitate.
        Invitațiile se trimit prin email și conțin un link unic, personal și netransferabil.
      </p>

      <h2>Configurare</h2>
      <p>
        În formularul de editare al activității, activează <strong>Necesită înregistrare</strong>,
        apoi <strong>Doar cu invitație</strong>. Salvează activitatea, apoi accesează pagina de invitații.
      </p>

      <h2>Trimiterea invitațiilor</h2>
      <ul>
        <li><strong>Emailuri</strong> — introdu adrese separate prin virgulă, punct și virgulă sau linie nouă.</li>
        <li><strong>Import CSV</strong> — lipește conținut CSV cu o coloană „email".</li>
      </ul>
      <p>Invitațiile duplicate (aceeași adresă pentru aceeași activitate) sunt ignorate automat.</p>

      <h2>Fluxul invitatului</h2>
      <ol>
        <li>Invitatul primește un email cu link personal.</li>
        <li>Accesează link-ul și se autentifică (Google, Facebook sau email).</li>
        <li>Sistemul verifică că adresa de email corespunde invitației.</li>
        <li>Invitatul poate <strong>accepta</strong> sau <strong>refuza</strong> (cu motiv opțional).</li>
      </ol>

      <h2>Statusuri invitații</h2>
      <ul>
        <li><strong>Trimis</strong> — invitația a fost trimisă, niciun răspuns.</li>
        <li><strong>Acceptat</strong> — invitatul a confirmat participarea.</li>
        <li><strong>Refuzat</strong> — invitatul a refuzat (motivul, dacă a fost furnizat, este vizibil).</li>
        <li><strong>Expirat</strong> — invitația a expirat (gestiune manuală).</li>
      </ul>

      <h2>Acțiuni staff</h2>
      <ul>
        <li><strong>Retrimite invitația</strong> — retrimite emailul de invitație.</li>
      </ul>
    </DocLayout>
  );
}
